<template>
  <md-card class="md-primary empty-card">
    <md-card-header>
      <md-card-header-text>
        <div class="md-title">Choose Topics</div>
      </md-card-header-text>
    </md-card-header>
    </md-card-header>
    <md-card-content>
       Select some topics in the sidebar to get started
     </md-card-content>
  </md-card>
</template>

<script>
export default {
  name: 'EmptyCard',
  data: () => ({})
}
</script>



// WEBPACK FOOTER //
// src/components/EmptyCard.vue